import PicklistMetadata from "../PicklistMetadata";

// What KIND of container a location is: Database, Schema, Catalog, Folder, Bucket and so on. The
// only field Ataccama makes mandatory on a location, and technology-dependent -- a relational source
// has schemas, object storage has buckets -- so it reads a list of values rather than an enum fixed
// in code, and a tenant can add the one their source actually uses.
class LocationTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "LocationType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Location Type";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default LocationTypePicklistMetadata;
